import * as React from "react";
import { FormikProps, Field, Form, withFormik } from "formik";
// import { RouteComponentProps } from "react-router-dom";
import { InputField } from "../../../../shared/InputField";
import { TemplateSub } from "../../../../../components/layouts/TemplateSub";
import NewButton from "../../../../../components/uiMerge/newButton";
import * as ROUTES from "../../../../../constants/routes";
import { 
  UpdatePasswordController, 
  UpdatePasswordMutationMutationVariables 
} from "@njoy/controller";
import { SuccessModal } from "../../../../../components/modals/sucessModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ToastMessage from "../../../../../hooks/useToast";
import { profileChangePasswordSchema } from "@njoy/common";
import { extractError } from "../../../../../utils/extractError";

interface ChangePasswordFormValues {
  password: string;
  newPassword: string;
  confirmNewPassword: string;
}

interface Props {
  onFinish: () => void;
  submit: (
    values: UpdatePasswordMutationMutationVariables
  ) => Promise<any>;
}

const ChangePasswordPageInner: React.FC<
  FormikProps<ChangePasswordFormValues> & Props
> = (props) => {

  return (
    <TemplateSub page={`Change Password`}>
      <Form className="flex flex-col mt-8 flex-1 px-[1rem]">
        <div className="w-full flex-1 flex flex-col">

          <label className="text-[#CECECF] opacity-90">Current Password</label>
          <Field
            name="password"
            placeholder="Current password"
            component={InputField}
            type="password"
          />

          <label className="text-[#CECECF] opacity-90">New Password</label>
          <Field
            name="newPassword"
            placeholder="New password"
            component={InputField}
            type="password"
          />

          <label
            className="text-white p-1 opacity-[80%]"
            htmlFor="confirmPassword"
          >
            Confirm Password
          </label>
          <Field
            name="confirmNewPassword"
            type="password"
            placeholder="Confirm new password"
            component={InputField}
          />
        </div>

        <div className="mb-[2rem]">
          <NewButton
            loading={props.isSubmitting}
            fullWidth
            variant="primary"
            type="submit"
            className="login-form-button"
          >
            Save Changes
          </NewButton>
        </div>
      </Form>
    </TemplateSub>
  );
};

const FormikChangePasswordPage = withFormik<Props, ChangePasswordFormValues>({
  validationSchema: profileChangePasswordSchema,
  validateOnChange: true,
  validateOnBlur: true,
  mapPropsToValues: () => ({
    password: "",
    newPassword: "",
    confirmNewPassword: "",
  }),
  handleSubmit: async (
    { password, newPassword, confirmNewPassword },
    { props, setErrors, setSubmitting, setTouched }
  ) => {
    try {
      setSubmitting(true);
      const errors = await props.submit({
        oldPassword: password,
        newPassword,
        confirmNewPassword,
      });

      if (errors) {
        setSubmitting(false);
        const normalizedErrors = {
          ...errors,
        };
        ToastMessage("error", extractError(normalizedErrors));
        setErrors(normalizedErrors);
        setTouched(
          Object.keys(normalizedErrors).reduce(
            (acc, key) => ({ ...acc, [key]: true }),
            {} as Record<string, boolean>
          )
        );
      } else {
        setSubmitting(false);
        ToastMessage("success", "Password updated successfully");
        props.onFinish();
      }
    } catch(error: any) {
      setSubmitting(false);
      ToastMessage("error", (error as Error)?.message || "Something went wrong. Please try again.");
    }
  },
})(ChangePasswordPageInner as any);

// Wrap with controller
export const ChangePasswordPage: React.FC = () => {
  const [visible, setVisible] = React.useState(false);
  // const [errorVisible, setErrorVisible] = React.useState(false);

  return (
    <UpdatePasswordController>
      {({ submit }) => (
        <>
          <ToastContainer />
          
          <FormikChangePasswordPage
            submit={async (values) => {
              const errors = await submit(values);
              if (!errors) {
                // show modal on success
                setVisible(true);
              } else {
                console.log(errors)
              }
              return errors;
            }}
            onFinish={() => setVisible(true)}
          />

          <SuccessModal
            visible={visible}
            onCancel={() => setVisible(false)}
            caption="Your password has been changed successfully."
            onClick={() => {
              setVisible(false);

              window.location.replace(ROUTES.ACCOUNT_DETAILS);
            }}
          />
        </>
      )}
    </UpdatePasswordController>
  );
};


